var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreakNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 14249"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#C0BAC1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.9111 13.017C20.0372 11.8469 19.1607 11.2331 19.1238 11.2075L18.9969 11.1197V13.0872C18.9969 13.3741 18.7613 13.6067 18.4708 13.6067C18.1802 13.6067 17.9446 13.3741 17.9446 13.0872V12.2561C17.9446 9.94036 16.4682 8.47606 16.093 8.07733C16.093 8.07733 15.5473 7.53866 15.2745 7.26933C15.0017 7 14.7289 7 14.7289 7L14.7522 7.78196C14.7347 9.09362 13.508 11.0175 11.2981 13.1993C9.68193 14.7949 8.99466 16.3101 9.00003 18.2658C9.00501 20.0704 9.737 21.7708 11.0612 23.0537C12.3594 24.3114 14.0529 25 15.8413 25C15.8782 25 15.9154 24.9997 15.9525 24.9991C17.7559 24.9704 19.4467 24.2553 20.7134 22.9855C21.9816 21.7143 22.68 20.0315 22.68 18.2471C22.68 16.3749 22.0683 14.5663 20.9111 13.017Z",
    fill: "#D9D9D9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreakNo);
export default __webpack_public_path__ + "static/media/streak-no.6706770780aca7cf7119b59d730502f3.svg";
export { ForwardRef as ReactComponent };